import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import * as styles from '../../styles/iconButton.module.css';

/**
 * Компонент кнопки с иконкой. <br />
 * Компонет умеет отображать иконки. Размер кнопки явно не задается, т.к. зависит от размеров иконки.
 */
import { jsx as _jsx } from "react/jsx-runtime";
var IconButtonComponent = /*#__PURE__*/React.forwardRef(function IconButton(props, ref) {
  var icon = props.icon,
    rest = _objectWithoutProperties(props, _excluded);
  var preparedIcon = /*#__PURE__*/React.cloneElement(icon, {
    color: 'currentColor'
  });
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({}, rest), {}, {
    className: styles['button'],
    ref: ref,
    children: preparedIcon
  }));
});
export var IconButton = /*#__PURE__*/React.memo(IconButtonComponent);